/**
 * #330 round 2 — the direction being edited, drawn live on the fleet map before it is saved (owner 2026-10-13:
 * "see the wedge change in real time"). The map's confirm box and the camera edit sheet write what their fields
 * hold; the fleet map draws it as a preview wedge. Save, Cancel and closing clear it. Not persisted: a reload
 * starts with nothing to preview.
 */
import { create } from 'zustand'
import type { DirectionDraft } from '@/components/map/MapView'

interface DirectionPreviewState {
  preview: DirectionDraft | null
  set: (preview: DirectionDraft) => void
  clear: () => void
}

const same = (a: DirectionDraft | null, b: DirectionDraft) =>
  !!a && a.id === b.id && a.heading === b.heading && a.fov === b.fov && a.rangeM === b.rangeM

export const useDirectionPreview = create<DirectionPreviewState>()((set) => ({
  preview: null,
  // the same values again change nothing, so the map is not drawn again for them
  set: (preview) => set((s) => (same(s.preview, preview) ? s : { preview })),
  clear: () => set((s) => (s.preview === null ? s : { preview: null })),
}))
